var _path, _rect, _path2, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 740,
    height: 50,
    viewBox: "0 0 740 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.7222 1.07977C38.4036 0.858768 1 15 1 15H414C414 15 386.398 0.606494 368.111 1.07977C352.108 1.49395 348.084 8.45132 332.056 8.67232C314.893 8.90896 309.885 0.843132 292.722 1.07977C276.693 1.30077 272.692 8.92657 256.667 8.67232C241.751 8.43568 238.68 1.85844 223.889 1.07977C204.571 0.0627587 197.464 9.11433 178 8.67232C160.856 8.28299 155.832 1.28686 138.667 1.07977C120.348 0.858768 114.374 8.89333 96.0556 8.67232C78.8902 8.46523 73.8875 1.28686 56.7222 1.07977Z",
    fill: "#0BE0D3",
    stroke: "#0BE0D3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 15,
    width: 413,
    height: 35,
    fill: "#0BE0D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M683.278 1.07977C701.596 0.858768 739 15 739 15H326C326 15 353.602 0.606494 371.889 1.07977C387.892 1.49395 391.916 8.45132 407.944 8.67232C425.107 8.90896 430.115 0.843132 447.278 1.07977C463.307 1.30077 467.308 8.92657 483.333 8.67232C498.249 8.43568 501.32 1.85844 516.111 1.07977C535.429 0.0627587 542.536 9.11433 562 8.67232C579.144 8.28299 584.168 1.28686 601.333 1.07977C619.652 0.858768 625.626 8.89333 643.944 8.67232C661.11 8.46523 666.112 1.28686 683.278 1.07977Z",
    fill: "#0BE0D3",
    stroke: "#0BE0D3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 413,
    height: 35,
    transform: "matrix(-1 0 0 1 739 15)",
    fill: "#0BE0D3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.ad86ca286f52596cfe450579bedfeba9.svg";
export { ForwardRef as ReactComponent };